var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',_vm._b({on:{"validate":_vm.checkValid},model:{value:(_vm.input_value),callback:function ($$v) {_vm.input_value=$$v},expression:"input_value"}},'vue-tel-input',_vm.bindProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }